import HomeNavRail from './HomeNavRail'
import HomeCodeNavRail from './components/HomeCodeNavRail'
import HomeCodePrimaryActions from './components/HomeCodePrimaryActions'
import HomePrimaryActions from './components/HomePrimaryActions'
import HomeVoiceNavRail from './components/HomeVoiceNavRail'
import HomeVoicePrimaryActions from './components/HomeVoicePrimaryActions'

export function renderSecondaryNavHomeSections(section, ctx) {
  const key = `${section.type}-${ctx.index}`

  if (section.type === 'homeVoicePrimaryActions') {
    return (
      <HomeVoicePrimaryActions
        key={key}
        onNewRecording={ctx.onDoVoice}
        newRecordingActive={ctx.doVoiceActive}
      />
    )
  }

  if (section.type === 'homeVoiceNavRail') {
    return <HomeVoiceNavRail key={key} />
  }

  if (section.type === 'homeCodePrimaryActions') {
    return (
      <HomeCodePrimaryActions
        key={key}
        onNewProject={ctx.onNewProject ?? ctx.onBuild}
        newProjectActive={Boolean(ctx.buildActive) && !ctx.selectedProjectId}
      />
    )
  }

  if (section.type === 'homeCodeNavRail') {
    return (
      <HomeCodeNavRail
        key={key}
        projects={ctx.projects}
        pinnedProjectIds={ctx.pinnedProjectIds}
        selectedProjectId={ctx.selectedProjectId}
        onProjectSelect={ctx.onProjectSelect}
        onRenameProject={ctx.onRenameProject}
      />
    )
  }

  if (section.type === 'homePrimaryActions') {
    return (
      <HomePrimaryActions
        key={key}
        onNewChat={ctx.onNewChat}
        onDocuments={ctx.onDocuments}
        onDoVoice={ctx.onDoVoice}
        documentsActive={ctx.documentsActive}
        doVoiceActive={ctx.doVoiceActive}
        buildActive={ctx.buildActive}
        selectedThreadId={ctx.selectedThreadId}
      />
    )
  }

  if (section.type === 'homeNavRail') {
    return <HomeNavRail key={key} {...ctx} />
  }

  return null
}
